class PostJs {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    // 画像（img）にwidth属性がある場合のサイズ制御
    const imgElements = document.querySelectorAll('img');
    imgElements.forEach((item, key) => {
      const itemWidth = item.getAttribute('width');
      item.style.width = itemWidth + 'px';
    })
  }
}
